/**
 * Shown after first sign-in if the user is not yet provisioned in our DB.
 * Their next step is offline — an Operations Manager needs to activate them.
 */

export function PendingApproval({ onSignOut }: { onSignOut: () => void }) {
  return (
    <div className="grid place-items-center h-full bg-gradient-to-br from-rogue-100 to-rogue-200">
      <div className="bg-white rounded-2xl shadow-lg pad-fluid w-[min(90vw,32rem)] text-center">
        <div className="text-2xl font-bold text-rogue-900 mb-2">Pending approval</div>
        <p className="text-rogue-700 mb-6">
          Your sign-in succeeded, but an Operations Manager needs to activate your account
          before you can use Atticor-Rogue. They'll receive a notification.
        </p>
        <button onClick={onSignOut} className="text-rogue-600 underline text-sm">
          Sign out
        </button>
      </div>
    </div>
  );
}
